module.exports = __webpack_public_path__ + "0dc78056b900fd84a93d81ab21231ebf.svg";